module.exports = __webpack_public_path__ + "static/img/tg_postnew.eb26015d.png";